export default __webpack_public_path__ + "static/media/conecrtina-coil-fencing-1918972.fa635336.jpg";